module.exports = __webpack_public_path__ + "static/media/choose_us_4_selected.7ff69ec5.png";